import React from "react";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {
      notificationItem: this.props.notificationItem,
    };
  },
  onError() {
    var updated = this.state.notificationItem;
    updated.thumbnail_image_url = "/images/ja2/img_noimage.gif";
    this.setState({
      notificationItem: updated,
    });
  },
  render() {
    var timeAgo = this.state.notificationItem.created_at_time_ago_format;
    var isUnread = this.state.notificationItem.is_read === false;
    return (
      <li className="notif-2026__item-wrap">
        <a
          href={this.props.notificationItem.url}
          id="notification-item"
          className={"notif-2026__item" + (isUnread ? " notif-2026__item--unread" : "")}
        >
          <div className="notif-2026__row">
            <div className="notif-2026__thumb-wrap">
              <img
                src={this.state.notificationItem.thumbnail_image_url}
                onError={this.onError}
                className="notif-2026__thumb"
                alt=""
              />
            </div>
            <div className="notif-2026__body">
              <div className="notif-2026__title-row">
                {isUnread && <span className="notif-2026__dot" aria-hidden="true" />}
                <p
                  className="notif-2026__body-title"
                  dangerouslySetInnerHTML={{
                    __html: this.state.notificationItem.title,
                  }}
                />
              </div>
              {this.state.notificationItem.body && (
                <p
                  className="notif-2026__body-text"
                  dangerouslySetInnerHTML={{
                    __html: this.state.notificationItem.body,
                  }}
                />
              )}
              <p className="notif-2026__time">{timeAgo}</p>
            </div>
          </div>
        </a>
      </li>
    );
  },
});
